<template>
  <form autocomplete="off">
    <div class="row">
      <div class="col-6 d-flex">
        <vs-select
          class="w-100"
          autocomplete
          :label="isMop ? 'Regiones' : 'Categorías'"
          description-text="Si no hay, puedes consultar con tu administrador"
          name="category"
          v-model="category"
          @change="onChange"
        >
          <vs-select-item
            v-for="(region, index) in categoryRegions"
            :key="index"
            :value="region.opcionId"
            :text="region.descripcion"
          />
        </vs-select>
        <vs-icon
          class="ml-2 mt-5 pt-3 cursor-pointer"
          color="danger"
          v-tooltip="'Quitar filtro'"
          size="medium"
          icon="highlight_off"
          @click="clearCategory()"
        />
      </div>
      <div class="col-6 d-flex">
        <vs-select
          class="w-100"
          autocomplete
          :label="isMop ? 'Servicios' : 'Subcategorías'"
          description-text="Si no hay, puedes consultar con tu administrador"
          name="servicio"
          v-model="subcategory"
          @change="onChange"
        >
          <vs-select-item
            v-for="(service, index) in categoryServices"
            :key="index"
            :value="service.opcionId"
            :text="service.descripcion"
          />
        </vs-select>
        <vs-icon
          class="ml-2 mt-5 pt-3 cursor-pointer"
          color="danger"
          v-tooltip="'Quitar filtro'"
          size="medium"
          icon="highlight_off"
          @click="clearSubcategory()"
        />
      </div>
      <div class="col 12 mt-5">
        <small class="badge badge-success">
          Los filtros se aplican automaticamente al seleccionarlos
        </small>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'OfficeFilters',
  props: {
    currentFilters: {
      type: Array
    },
    clearCategory: {
      type: Function
    },
    clearSubcategory: {
      type: Function
    }
  },
  data() {
    return {
      category: null,
      subcategory: null
    };
  },
  watch: {
    currentFilters() {
      this.populateFields();
    },
    category(value) {
      if (!value) return;
      this.$emit('category', `regionId:${value}`);
    },
    subcategory(value) {
      if (!value) return;
      this.$emit('subcategory', `servicioId:${value}`);
    }
  },
  computed: {
    ...mapGetters('Herramientas', [
      'categoryRegions',
      'categoryServices'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ])
  },
  methods: {
    ...mapActions('Herramientas', [
      'listCategories',
    ]),
    onChange(value) {
      if (value) this.notify();
    },
    populateFields() {
      const category = this.currentFilters.find(
        (obj) => obj.key === 'regionId'
      )?.filter.split(':')[1];
      const subcategory = this.currentFilters.find(
        (ob) => ob.key === 'serviceId'
      )?.filter.split(':')[1];
      // eslint-disable-next-line
      category ? this.category = category : this.category = null;
      // eslint-disable-next-line
      subcategory ? this.subcategory = subcategory : this.subcategory = null;
    },
    notify() {
      this.$bvToast.toast(
        'Filtro aplicado!',
        {
          title: '¡Bien!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
    }
  },
  created() {
    this.populateFields();
    this.isMop = this.company.iut === '61202000-0';
    this.listCategories({
      grupoOpcion: 'tipos.regiones-ed',
      deshabilitado: 'si'
    });
    this.listCategories({
      grupoOpcion: 'tipos.servicios-ed',
      deshabilitado: 'si'
    });
  }
};
</script>
